export default {
  viewBox: "0 0 24 24",
  html: "<path fill=\"none\" d=\"M0 0h24v24H0z\"/><path d=\"M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8\"/>"
};